<template>
  <div class="teacher_training_wrap">
    <div class="class_number_statistics_single">
      <h2>
        班级人数<span>{{overallProgressData.studentNum}}</span>
        在学人数<span>{{overallProgressData.studyNum}}</span>
        未学人数<span>{{overallProgressData.noStudyNum}}</span>
        <!-- 小组人数<span>23</span> -->
        <!-- 在学人数<span>45</span> -->
      </h2>
      <!-- <el-button @click="viewClassProgress">查看详情</el-button> -->
    </div>
    <div class="course_progress">
      <h2>课程进度</h2>
      <div class="progress_div">
        <span>整体课程进度</span>
        <div style="width: 80%;float:left;margin: 15px 0 0 20px;">
          <el-progress :show-text="true" :stroke-width="6" :percentage="overallProgressData.progress"></el-progress>
        </div>
      </div>
      <div class="progress_div" v-for="(item,i) in groupProgress" :key="i">
        <span :title="item.teamName">{{item.teamName}}</span>
        <div style="width: 80%;float:left;margin: 15px 0 0 20px;">
          <el-progress :show-text="true" :stroke-width="6" :percentage="item.progressWeight"></el-progress>
        </div>
      </div>
    </div>
    <div>
      <div class="recent_learning_num" style="width:100%">
        <h2>最近学习人数
          <!-- <span>今日学习人数<i>22</i></span> -
          <span>日均学习人数<i>22</i></span> -->
        </h2>
        <div class="broken_line_diagram">
          <p @click="tabLearnType">
            <b :class="learnType==7?'active':''">周</b>
            <b :class="learnType==30?'active':''">月</b>
          </p>
          <ve-line
           :data="learnChartData"
           :settings="chartSettings"
           :extend="peopleExtend"
           width="98%"
           height="350px"
           :legend-visible="false"
           :colors="colors"></ve-line>
        </div>
      </div>
      <div class="learning_hours_today" v-if="false">
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch="true">
          <el-tab-pane label="今日学习时长排行" name="first">
            <p class="prompting_language">（包括视频、音频、文档、图片类学习时长）</p>
            <ul class="ranking_list">
              <li>
                <span><img src="/static/images/study/statistics/first.png" alt=""></span>
                <span>1</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="/static/images/study/statistics/second.png" alt=""></span>
                <span>2</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="/static/images/study/statistics/thrid.png" alt=""></span>
                <span>3</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="" alt=""></span>
                <span>4</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
              <li>
                <span><img src="" alt=""></span>
                <span>5</span>
                <span>张三</span>
                <span>10小时24分钟</span>
              </li>
            </ul>
            <p class="view_more" @click="viewLearningDuration">查看更多</p>
          </el-tab-pane>
          <el-tab-pane label="总学习时长排行" name="second">总学习时长排行</el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div style="clear: both;"></div>
    <!-- <div v-if="deptId=='506'"> -->
<!--    <div class="study_length_statistics">-->
<!--      <h2>学习时长统计</h2>-->
<!--      <div class="histogram_statistics" v-if="studyLengthData.rows.length>0">-->
<!--        <ve-histogram-->
<!--         :extend="studyLengthExtend" -->
<!--         :data="studyLengthData" -->
<!--         :data-zoom="studyLengthDataZoom"-->
<!--         :legend-visible="false"-->
<!--         width="96%" -->
<!--         height="320px"></ve-histogram>-->
<!--      </div>-->
<!--      <div v-else class="no_data">-->
<!--        <img src="/static/images/wujieguo.png" alt="">-->
<!--        <p>暂无统计结果</p>-->
<!--      </div>-->
<!--    </div>-->
    <div class="student_accuracy_statistics">
      <h2>分小组正确率统计</h2>
      <div class="histogram_statistics" v-if="studentAccuracyData.rows.length>0">
        <ve-histogram
         :extend="studentAccuracyExtend"
         :data="studentAccuracyData"
         :data-zoom="dataZoom"
         :legend-visible="false"
         width="96%"
         height="320px"></ve-histogram>
      </div>
      <div v-else class="no_data">
        <img src="/static/images/wujieguo.png" alt="">
        <p>暂无统计结果</p>
      </div>
    </div>
    <div class="post_accuracy_statistics">
      <h2>分岗位小组正确率统计</h2>
      <ul v-if="postAccuracyStatisticsData.length>0">
        <li v-for="(item, i) in postAccuracyStatisticsData" :key="i">
          <el-progress type="circle" :percentage="item.postRate" :color="postAccuracyColor[i]"></el-progress>
          <p>{{item.postName}}</p>
          <p>参与小组数：<span>{{item.teamNum?item.teamNum:0}}个</span></p>
        </li>
      </ul>
      <div v-else class="no_data">
        <img src="/static/images/wujieguo.png" alt="">
        <p>暂无统计结果</p>
      </div>
    </div>
    <div class="group_comprehensive_strength">
      <h2>组队综合实力最新排行榜
        <span style="font-size: 13px;color: red">(算法规则:取小组正确率和完成任务数作为综合统计指标)</span>
      </h2>
      <ul v-if="groupComprehensiveStrength.length>0">
        <li>
          <div>排行</div>
          <div>小组名称</div>
          <div>实力值</div>
          <div>小组成员</div>
          <div>小组标语</div>
        </li>
        <li v-for="(item,i) in groupComprehensiveStrength" :key="i">
          <div>
            <img src="/static/images/study/statistics/first.png" alt="" v-if="i==0">
            <img src="/static/images/study/statistics/second.png" alt="" v-else-if="i==1">
            <img src="/static/images/study/statistics/thrid.png" alt="" v-else-if="i==2">
            <span v-else>{{i+1}}</span>
          </div>
          <div>{{item.teamName}}</div>
          <div>{{item.rate}}%</div>
          <div>{{item.teamUserNames}}</div>
          <div>{{item.teamTitle}}</div>
        </li>
      </ul>
      <div v-else class="no_data">
        <img src="/static/images/wujieguo.png" alt="">
        <p>暂无统计结果</p>
      </div>
    </div>
    <div class="discuss_statistics">
      <h2>讨论</h2>
      <div class="class_discuss">
        <div class="class_discuss_title">
          <h3>班级 <span @click="viewClassDiscuss">查看详情<i></i></span></h3>
          <!-- <p>今日：发起主题数 <span>{{discussData.today_theme}}</span>条 - 回复数 <span>{{discussData.today_reply}}</span>条 - 评论数 <span>{{discussData.today_comment}}</span>条</p> -->
        </div>
        <div class="class_discuss_progress">
          <el-progress type="circle" :percentage="discussData.departDegress" color="#34D3B0"></el-progress>
          <p>讨论参与度</p>
        </div>
        <ul class="class_discuss_details">
          <li>
            <p><span>{{discussData.theme_reply_comment_num}}</span>条</p>
            <p>主题、回复及评论总数</p>
          </li>
          <li>
            <div class="lis_left">
              <p><span>{{discussData.theme_num}}</span>条</p>
              <p>主题数</p>
            </div>
            <div class="lis_right">
              <p>老师答疑区主题：<span>{{discussData.teacher_theme_num}}</span>条</p>
              <p>课堂交流区主题：<span>{{discussData.student_theme_num}}</span>条</p>
            </div>
          </li>
          <li>
            <p><span>{{discussData.reply_comment_num}}</span>条</p>
            <p>回复和评论数</p>
          </li>
        </ul>
      </div>
      <div class="personal_discuss">
        <h3>个人</h3>
        <ul>
          <li>
            <p><span>{{personalDiscuss.pubThemeNum}}</span>条</p>
            <p>发布主题数</p>
          </li>
          <li>
            <el-progress type="circle" :percentage="personalDiscuss.replyDegree" color="#FFB23C"></el-progress>
            <p>主题回复率（{{personalDiscuss.replyNum}}/{{personalDiscuss.totalReplyNum}}）</p>
          </li>
          <li>
            <el-progress type="circle" :percentage="personalDiscuss.departDegree" color="#5397F7"></el-progress>
            <p>主题参与率（{{personalDiscuss.departNum}}/{{personalDiscuss.totalDepartNum}}）</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="student_open_notes_transverse">
      <h2>学生公开笔记</h2>
      <ul>
        <!-- <li>
          <p><span>{{noteData.todayNum}}</span>条</p>
          <p>今日公开笔记数</p>
          <img src="/static/images/study/statistics/arrow.png" alt="" @click="viewPublicNotes('first')">
        </li> -->
        <li>
          <p><span>{{noteData.totalNum}}</span>条</p>
          <p>公开笔记总数</p>
          <img src="/static/images/study/statistics/arrow.png" alt="" @click="viewPublicNotes('second')">
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import cc from '@/components/views/studyCenter/switch/statistics/teacher/tooltip'
import qs from 'qs'
import * as api from '@/api/HNstatisticsApi'
export default {
  components: {cc},
  data() {
    this.chartSettings = {
      stack: { '用户': ['访问人数'] },
      area: true,
      itemStyle:{ //面积图颜色设置
        color:{
          type:'linear',
          x:0,
          y:0,
          x2:0,
          y2:1,
          colorStops:[
            {
              offset: 0,
              color: 'rgba(83,151,247,0.8)', // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(255,255,255,1)' // 100% 处的颜色
            },
          ],
          globalCoord: false
        }
      },
    }
    this.peopleExtend = {
      series: {
        label: {
          normal: {
            show: true
          }
        }
      }
    }
    return {
      courseId: this.$route.query.id,
      classId: this.$route.query.classId,
      overallProgressData: { //班级人数及进度
        progress: 0,
        studentNum: 0,
        studyNum: 0,
        noStudyNum: 0,
      },
      learnChartData: { //最近学习人数
        columns: ['时间', '访问人数'],
        rows: []
      },
      colors: ['#5397F7'],
      learnType: 7,
      activeName: 'first',
      discussData: {//班级讨论
        departDegress: 0,
        reply_comment_num: 0,
        theme_num: 0,
        theme_reply_comment_num: 0,
        teacher_theme_num: 0,
        student_theme_num: 0,
        today_theme: 0,
        today_reply: 0,
        today_comment: 0
      },
      personalDiscuss: {//个人讨论
        pubThemeNum: 0,
        replyDegree: 0,
        replyNum: 0,
        totalReplyNum: 0,
        departDegree: 0,
        departNum: 0,
        totalDepartNum: 0
      },
      noteData: {
        todayNum: 0,
        totalNum: 0
      },
      studentAccuracyData: {//分学生正确统计率-柱状图
        columns: ['name', 'weights'],
        rows: []
      },
      studentAccuracyList: [//分学生正确统计率-划过
        // { '会计核算岗': 0.1 ,'票据岗': 0.1, '税务岗': 0.2 ,'出纳岗': 0.3},
        // { '会计核算岗': 0.2 ,'票据岗': 0.1, '税务岗': 0.2 ,'出纳岗': 0.3},
        // { '会计核算岗': 0.3 ,'票据岗': 0.1, '税务岗': 0.2 ,'出纳岗': 0.3},
        // { '会计核算岗': 0.4 ,'票据岗': 0.1, '税务岗': 0.2 ,'出纳岗': 0.3},
        // { '会计核算岗': 0.5 ,'票据岗': 0.1, '税务岗': 0.2 ,'出纳岗': 0.3},
        // { '会计核算岗': 0.6 ,'票据岗': 0.1, '税务岗': 0.2 ,'出纳岗': 0.3},
      ],
      studentAccuracyExtend: null,
      dataZoom: null,
      postAccuracyStatisticsData: [],//分岗位正确统计率
      postAccuracyColor: ['#5397F7', '#FD785A', '#FECB61', '#34D3B0', '#FFB23C'],
      groupProgress: [],
      groupComprehensiveStrength: [],
      value: '',
      deptId: sessionStorage.getItem('deptId'),
      studyLengthData: {//学习时长统计数据-柱状图
        columns: ['name', 'weights'],
        rows: []
      },
      studyLengthExtend: null,
      studyLengthDataZoom: null,
    }
  },
  created() {

  },
  mounted() {
    this.init()
    this.getPostData()
  },
  methods: {
    init(){
      this.getPeopleNum() //班级人数
      this.getCourseProgress() //课程进度
      this.getRecentLearningNum() //最近学习人数
      this.getDiscussData() //班级讨论
      this.getOwnDiscussData() //个人讨论
      this.getNoteData() //公开笔记
      // this.getStudyLength() //学习时长统计
      this.getGroupAccuracy() //分小组正确率统计
      this.getGroupComprehensiveStrength()//组队综合实力排行榜
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    viewClassProgress(){//查看班级进度
      let that = this
      this.$router.push({
        path:'/statisticsPage/classProgress',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className
        }
      })
    },
    viewLearningDuration(){//查看学习时长
      let that = this
      this.$router.push({
        path:'/statisticsPage/learningDuration',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className
        }
      })
    },
    viewClassDiscuss(){//查看班级讨论
      let that = this
      this.$router.push({
        path:'/statisticsPage/classDiscuss',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className
        }
      })
    },
    viewPublicNotes(flag){//查看公开笔记
      let that = this
      this.$router.push({
        // path:'/statisticsPage/publicNotes',
        path:'/statisticsPage/publicNoteList',
        query: {
          id: that.$route.query.id,
          classId: that.$route.query.classId,
          className: that.$route.query.className,
          // flag: flag
        }
      })
    },
    getPeopleNum(){//班级人数
      api.getClassNum(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.overallProgressData.studentNum = rs.data.studentNum
          this.overallProgressData.studyNum = rs.data.studyNum
          this.overallProgressData.noStudyNum = rs.data.noStudyNum
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getCourseProgress(){//课程进度及小组进度
      let that = this
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId
      }
      api.getCourseProgress(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          that.groupProgress = []
          that.overallProgressData.progress = Math.ceil(rs.data.totalWeight*100)
          rs.data.result.forEach(v=>{
            let obj = {
              classId: v.classId,
              courseId: v.courseId,
              progressWeight: Math.ceil(v.progressWeight*100),
              teamId: v.teamId,
              teamName: v.teamName,
              teamTitle: v.teamTitle
            }
            that.groupProgress.push(obj)
          })
        }else{
          if(rs.msg == '未查詢到任何進度'){
            that.groupProgress = []
          }else{
            this.$messageError(rs.msg)
          }
        }
      })
    },
    getRecentLearningNum(){//最近学习人数
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
        "type": this.learnType
      }
      api.getLearningNum(obj).then(rs=>{
        if(rs.code==0){
          this.learnChartData.rows = []
          rs.data.list.forEach(v=>{
            let obj = { '时间': v.time, '访问人数': v.num }
            this.learnChartData.rows.push(obj)
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getDiscussData(){//班级讨论详情
      api.getDiscussData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.discussData = {
            departDegress: rs.data.departDegress?rs.data.departDegress:0,
            reply_comment_num: rs.data.reply_comment_num,
            theme_num: rs.data.theme_num,
            theme_reply_comment_num: rs.data.theme_reply_comment_num,
            teacher_theme_num: rs.data.themeData[0].num,
            student_theme_num: rs.data.themeData[1]?rs.data.themeData[1].num:0,
            today_theme: rs.data.todayData[0].num,
            today_reply: rs.data.todayData[1].num,
            today_comment: rs.data.todayData[2].num,
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getOwnDiscussData(){//个人讨论详情
      api.getOwnDiscussData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.personalDiscuss = {
            pubThemeNum: rs.data.pubThemeNum,
            replyDegree: rs.data.replyDegree,
            replyNum: rs.data.replyNum,
            totalReplyNum: rs.data.totalReplyNum,
            departDegree: rs.data.departDegree,
            departNum: rs.data.departNum,
            totalDepartNum: rs.data.totalDepartNum
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    tabLearnType(){
      if(this.learnType==7){
        this.learnType = 30
      }else{
        this.learnType = 7
      }
      this.getRecentLearningNum()
    },
    getPostData(){//分岗位正确统计率
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
      }
      // this.$ajax.post('/api-eval/qry-post-statistics',obj).then(rs=>{
      api.getPostDataTeam(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          this.postAccuracyStatisticsData = []
          rs.data.forEach(v=>{
            let obj = {
              classId: v.classId,
              courseId: v.vcourseId,
              postId: v.postId,
              postName: v.postName,
              postRate: Math.ceil(v.postRate*100),
              teamNum: v.teamNum
            }
            this.postAccuracyStatisticsData.push(obj)
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getStudyLength(){//学习时长统计
      let that = this
      api.getLearnTimeTeacher(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          that.studyLengthData.rows = []
          rs.data.forEach((v)=>{
            let obj = {'name': v.studentName, 'weights': v.learnTime}
            that.studyLengthData.rows.push(obj)
          })
          that.studyLengthExtend = {
            tooltip: {
              trigger: 'axis',
              formatter: function(params){
                let userName = that.studyLengthData.rows[params[0].dataIndex].name
                let time = that.studyLengthData.rows[params[0].dataIndex].weights
                let content = '<div style="color: #fff"><span>学习时长：</span>'+time+' min</div>'
                var res;
                res = '<div class="tooltip_hv"><span>'+userName+'</span>'+content+'</div>';
                return res
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value} min'
              },
            },
            series: {
              barMaxWidth: 30,
              label: {
                normal: {
                  show: true,
                  position: "top",
                  formatter: ({ value }) => value + 'min'
                }
              }
            }
          }
          that.studyLengthDataZoom = [
            {
              type: 'slider',
              start: 0,
              end: 100
            }
          ]
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getGroupAccuracy(){//分小组正确统计率
      let that = this
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId
      }
      api.getGroupAccuracy(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          this.studentAccuracyData.rows = []
          rs.data.outLayerList.forEach(v=>{
            let obj = {'name':v.teamName,'weights':Math.ceil(v.rate*100)}
            this.studentAccuracyData.rows.push(obj)
          })
          this.studentAccuracyList = rs.data.internalList
          let that = this
          this.studentAccuracyExtend = {
            tooltip: {
              trigger: 'axis',
              formatter: function(params){
                let data = that.studentAccuracyList[params[0].dataIndex]
                let arr = []
                let userName = that.studentAccuracyData.rows[params[0].dataIndex].name
                $.each(data,function(key,value){
                  let str = '<div style="color: #fff"><span>'+value.postName+'('+value.userName+')：</span>'+Math.ceil(value.rate*100)+'%</div>'
                  arr.push(str)
                })
                let content = arr.join(' ')
                var res;
                res = '<div class="tooltip_hv"><span>'+userName+'</span>'+content+'</div>';
                return res
              }
            },
            yAxis: {
              type: 'value',
              max: 100,
              axisLabel: {
                formatter: '{value} %'
              },
            },
            series: {
              barMaxWidth: 30,
              label: {
                normal: {
                  show: true,
                  position: "top",
                  formatter: ({ value }) => value + '%'
                }
              }
            }
          }
          this.dataZoom = [
            {
              type: 'slider',
              start: 20,
              end: 80
            }
          ]
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getGroupComprehensiveStrength(){//排行榜
      let that = this
      let obj = {
        "classId": this.classId,
        "courseId": this.courseId,
      }
      api.getGroupComprehensiveStrength(qs.stringify(obj)).then(rs=>{
        if(rs.code==0){
          that.groupComprehensiveStrength = []
          that.groupComprehensiveStrength = rs.data;
          //
          [].forEach.call(that.groupComprehensiveStrength, item1 => {
            [].forEach.call(that.groupProgress, item2 => {
              if(item1.teamId == item2.teamId){
                item1.rate = Math.ceil(item1.rate*item2.progressWeight*100)
              }
            })
          })
          that.groupComprehensiveStrength = that.groupComprehensiveStrength.sort((a, b)=>{
            return b.rate - a.rate
          })
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
    getNoteData(){//笔记详情
      api.getNoteData(this.courseId,this.classId).then(rs=>{
        if(rs.code==0){
          this.noteData = {
            todayNum: rs.data.todayNum,
            totalNum: rs.data.totalNum
          }
        }else{
          this.$messageError(rs.msg)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
  .teacher_training_wrap{
    width: 100%;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
    overflow-y: auto;
    .class_number_statistics_single{
      height: 48px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-bottom: 16px;
      position: relative;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:48px;
        color:#333333;
        margin-left: 24px;
        span{
          margin: 10px;
          &:nth-child(1){color:#5397F7;}
          &:nth-child(2){color:#5397F7;}
          &:nth-child(3){color:#FF785A;}
          &:nth-child(4){color:#5397F7;}
          &:nth-child(5){color:#5397F7;}
        }
      }
      button{
        position: absolute;
        right: 64px;
        top: 9px;
        width:72px;
        height:30px;
        background:rgba(255,255,255,1);
        border:1px solid #5397F7;
        border-radius:4px;
        color: #5397F7;
        padding: 0;
        font-size: 12px;
      }
    }
    .course_progress{
      background: #fff;
      margin-bottom: 16px;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:48px;
        color:#333333;
        margin-left: 24px;
        span{
          margin: 10px;
          &:nth-child(1){color:#5397F7;}
          &:nth-child(2){color:#5397F7;}
          &:nth-child(3){color:#FF785A;}
          &:nth-child(4){color:#5397F7;}
          &:nth-child(5){color:#5397F7;}
        }
      }
      /deep/ .progress_div{
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: center;
        span{
          float: left;
          font-size:14px;
          color:rgba(51,51,51,1);
          margin-top: 15px;
          width: 100px;
          text-align: right;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .el-progress__text{
          font-size:12px !important;
          font-weight:400;
          color:rgba(83,151,247,1);
          margin-left: 20px;
        }
      }
    }
    .recent_learning_num{
      width:calc(75% - 16px);
      height:334px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      float: left;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
        span{
          font-size:12px;
          font-weight:400;
          line-height:16px;
          color:rgba(153,153,153,1);
          i{
            color: #5397F7;
            margin: 0 5px;
          }
          &:first-child{
            margin-left: 24px;
          }
          &:last-child{
            margin-left: 3px;
          }
        }
      }
      .broken_line_diagram{
        width: 100%;
        height: 300px;
        padding-left: 70px;
        box-sizing: border-box;
        position: relative;
        p{
          position: absolute;
          right: 25px;
          top: -20px;
          padding: 0;
          width: 56px;
          height: 24px;
          display: flex;
          border-radius: 4px;
          border: none;
          overflow: hidden;
          cursor: pointer;
          b{
            display: inline-block;
            width: 28px;
            height: 24px;
            font-weight: 400;
            background: #E8F2FF;
            font-size: 12px;
            line-height: 24px;
            text-align: center;
            color: #5397F7;
          }
          .active{
            background: #5397F7;
            color: #fff;
          }
        }
      }
    }
    /deep/ .learning_hours_today{
      width:25%;
      height:334px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      float: right;
      padding: 0 24px;
      box-sizing: border-box;
      .el-tabs__active-bar{
        background-color: #333;
      }
      .el-tabs__item.is-active{
        color: #333;
        font-weight: 600;
      }
      .prompting_language{
        font-size:12px;
        font-weight:400;
        color:rgba(244,61,61,1);
      }
      .ranking_list{
        margin-top: 24px;
        li{
          height: 40px;
          display: flex;
          align-items: center;
          span{
            &:nth-child(1){
              width: 24px;
              height: 24px;
              img{
                width: 100%;
              }
            }
            &:nth-child(2){
              width:50px;
              font-size:20px;
              font-weight:bold;
              color:rgba(51,51,51,1);
              margin-left: 5px;
            }
            &:nth-child(3){
              width:80px;
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
            }
            &:nth-child(4){
              font-size:14px;
              font-weight:400;
              color:rgba(102,102,102,1);
            }
          }
        }
      }
      .view_more{
        text-align: center;
        font-size:12px;
        font-weight:400;
        color:rgba(83,151,247,1);
        margin-top: 13px;
        cursor: pointer;
      }
    }
    .study_length_statistics{
      height:350px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-top: 16px;
      h2{
        font-size:16px;
        font-weight:600;
        // line-height:48px;
        padding-top: 16px;
        color:#333333;
        margin-left: 24px;
      }
      .histogram_statistics{
        padding-left: 3%;
      }
    }
    .student_accuracy_statistics{
      height:350px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-top: 16px;
      h2{
        font-size:16px;
        font-weight:600;
        // line-height:48px;
        padding-top: 16px;
        color:#333333;
        margin-left: 24px;
      }
      .histogram_statistics{
        padding-left: 3%;
      }
    }
    .post_accuracy_statistics{
      height:270px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin-top: 16px;
      h2{
        font-size:16px;
        font-weight:600;
        color:#333333;
        margin-left: 24px;
        padding-top: 16px;
      }
      ul{
        display: flex;
        width: 80%;
        justify-content: space-around;
        margin: 30px 10% 0;
        overflow: hidden;
        overflow-x: auto;
        /deep/ li{
          width: 115px;
          text-align: center;
          p{
            margin-top: 18px;
            line-height:19px;
            color:rgba(51,51,51,1);
            font-size: 14px;
            &:last-child{
              margin-top: 6px;
              font-size: 12px;
              span{
                color: #5397F7;
              }
            }
          }
          .el-progress-circle{
            width: 115px !important;
            height: 115px !important;
          }
        }
      }
    }
    /deep/ .discuss_statistics{
      height:320px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin: 16px 0;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
        margin-bottom: 16px;
      }
      .class_discuss{
        width:60%;
        height:230px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(235,235,235,1);
        border-radius:4px;
        float: left;
        margin-left: 24px;
        .class_discuss_title{
          height: 58px;
          display: flex;
          align-items: center;
          h3{
            font-size:16px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-left: 24px;
            span{
              font-size: 12px;
              cursor: pointer;
              color: #5397F7;
              margin-left: 8px;
              i{
                display: inline-block;
                width: 8px;
                height: 8px;
                margin-left: 5px;
                background: url('/static/images/newLoginPage/icon2.png') no-repeat;
                background-size: 100%;
              }
            }
          }
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-left: 16px;
            span{
              color: #5397F7;
            }
          }
        }
        .class_discuss_progress{
          width: 180px;
          float: left;
          text-align: center;
          p{
            font-size:12px;
            font-weight:400;
            color:rgba(51,51,51,1);
            margin-top: 8px;
          }
        }
        .class_discuss_details{
          width: calc(100% - 185px);
          height: 120px;
          float: right;
          display: flex;
          align-items: center;
          li{
            height:88px;
            background:rgba(255,255,255,1);
            box-shadow:0px 4px 8px rgba(0,0,0,0.14);
            border-radius:4px;
            padding: 17px 0 0 20px;
            box-sizing: border-box;
            &:nth-child(1){
              width: 160px;
              p{
                font-size:12px;
                font-weight:400;
                line-height:16px;
                color:rgba(51,51,51,1);
                span{
                  color: #5397F7;
                  font-size: 28px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 32px;
                    height: 1px;
                    background: #E6E6E6;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }
                &:nth-child(2){
                  margin-top: 8px;
                }
              }
            }
            &:nth-child(2){
              width: 240px;
              margin: 0 3%;
              display: flex;
              .lis_left{
                position: relative;
                p{
                  font-size:12px;
                  font-weight:400;
                  line-height:16px;
                  color:rgba(51,51,51,1);
                  span{
                    color: #5397F7;
                    font-size: 28px;
                    position: relative;
                    &::after{
                      content: "";
                      width: 32px;
                      height: 1px;
                      background: #E6E6E6;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                    }
                  }
                  &:nth-child(2){
                    margin-top: 8px;
                  }
                }
                &::after{
                  content: "";
                  width: 1px;
                  height: 22px;
                  background: #E6E6E6;
                  position: absolute;
                  right: -19px;
                  top: 12px;
                  margin: auto;
                }
              }
              .lis_right{
                margin-left: 40px;
                margin-top: 3px;
                p{
                  font-size:12px;
                  font-weight:400;
                  line-height:16px;
                  color:rgba(51,51,51,1);
                  span{
                    color: #5397F7;
                  }
                  &:nth-child(1){
                    position: relative;
                    &::after{
                      content: "";
                      width: 58px;
                      height: 1px;
                      background: #E6E6E6;
                      position: absolute;
                      bottom: -5px;
                      left: 0;
                    }
                  }
                  &:nth-child(2){
                    margin-top: 11px;
                  }
                }
              }
            }
            &:nth-child(3){
              width: 120px;
              p{
                font-size:12px;
                font-weight:400;
                line-height:16px;
                color:rgba(51,51,51,1);
                span{
                  color: #5397F7;
                  font-size: 28px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 32px;
                    height: 1px;
                    background: #E6E6E6;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }
                &:nth-child(2){
                  margin-top: 8px;
                }
              }
            }
          }
        }
      }
      .personal_discuss{
        width:calc(40% - 72px);
        height:230px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(235,235,235,1);
        border-radius:4px;
        float: right;
        margin-right: 24px;
        h3{
          font-size:16px;
          font-weight:400;
          color:rgba(51,51,51,1);
          margin: 16px 0 0 24px;
        }
        ul{
          display: flex;
          li{
            &:nth-child(1){
              width:120px;
              height:88px;
              background:rgba(255,255,255,1);
              box-shadow:0px 4px 8px rgba(0,0,0,0.14);
              border-radius:4px;
              padding: 17px 0 0 20px;
              box-sizing: border-box;
              margin: 38px 5% 0 26px;
              p{
                font-size:12px;
                font-weight:400;
                line-height:16px;
                color:rgba(51,51,51,1);
                span{
                  color: #5397F7;
                  font-size: 28px;
                  position: relative;
                  &::after{
                    content: "";
                    width: 32px;
                    height: 1px;
                    background: #E6E6E6;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                  }
                }
                &:nth-child(2){
                  margin-top: 8px;
                }
              }
            }
            &:nth-child(2){
              text-align: center;
              margin-top: 26px;
              p{
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin-top: 8px;
              }
            }
            &:nth-child(3){
              text-align: center;
              margin-left: 16px;
              margin-top: 26px;
              p{
                font-size:12px;
                font-weight:400;
                color:rgba(51,51,51,1);
                margin-top: 8px;
              }
            }
            .el-progress-circle{
              width: 115px !important;
              height: 115px !important;
              // margin-top: 12px;
            }
          }
        }
      }
    }
    .student_open_notes{
      width: 260px;
      height: 100%;
      min-height:360px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
      }
      ul{
        li{
          width:200px;
          height:88px;
          box-shadow:0px 4px 8px rgba(0,0,0,0.14);
          border-radius:4px;
          margin-left: 30px;
          margin-top: 40px;
          position: relative;
          padding-top: 18px;
          box-sizing: border-box;
          &:first-child{
            background: #5397F7;
          }
          &:last-child{
            background: #34D3B0;
          }
          p{
            font-size:12px;
            color:rgba(255,255,255,1);
            margin-left: 20px;
            span{
              font-size: 28px;
              font-weight:600;
              margin-right: 5px;
            }
            &:nth-child(2){
              margin-top: 8px;
            }
          }
          img{
            width: 20px;
            height: 20px;
            position: absolute;
            right: 20px;
            top: 0;
            bottom: 0;
            margin: auto;
            cursor: pointer;
          }
        }
      }
    }
    .student_open_notes_transverse{
      height:100px;
      background:rgba(255,255,255,1);
      border-radius:4px;
      display: flex;
      align-items: center;
      h2{
        font-size:16px;
        color:rgba(51,51,51,1);
        margin-left: 24px;
        font-weight: 600;
      }
      ul{
        height:100px;
        display: flex;
        align-items: center;
        li{
          width:320px;
          height:56px;
          box-shadow:0px 4px 8px rgba(0,0,0,0.14);
          border-radius:4px;
          display: flex;
          align-items: center;
          position: relative;
          &:first-child{
            background:#5397F7;
            margin-left: 180px;
          }
          &:last-child{
            background:#34D3B0;
            margin-left: 106px;
          }
          p{
            font-size:12px;
            line-height:16px;
            color:rgba(255,255,255,1);
            position: relative;
            &:nth-child(1){
              span{
                font-size: 28px;
                font-weight: 600;
                margin-left: 48px;
                margin-right: 5px;
              }
            }
            &:nth-child(2){
              margin-left: 47px;
              &::after{
                content: '';
                width: 1px;
                height: 10px;
                position: absolute;
                left: -20px;
                top: 4px;
                background: #fff;
              }
            }
          }
          img{
            width: 20px;
            height: 20px;
            position: absolute;
            top: 18px;
            right: 18px;
          }
        }
      }
    }
    .group_comprehensive_strength{
      background:rgba(255,255,255,1);
      border-radius:4px;
      margin: 16px 0;
      padding-bottom: 24px;
      position: relative;
      min-height: 240px;
      h2{
        font-size:16px;
        font-weight:600;
        line-height:21px;
        color:rgba(51,51,51,1);
        padding: 16px 0 0 24px;
        margin-bottom: 16px;
        position: relative;
      }
      ul{
        margin: 32px 90px 0;
        border: 1px solid #F2F2F2;
        li{
          height: 40px;
          background: #EFF5FF;
          display: flex;
          align-items: center;
          &:nth-child(even){
            background: #fff;
          }
          div{
            font-size:14px;
            font-weight:400;
            color:rgba(102,102,102,1);
            text-align: center;
            &:nth-child(1){
              width: 100px;
              img{
                width: 18px;
                // height: 22px;
              }
              span{
                font-size: 20px;
                color: #333;
                font-weight: 600;
              }
            }
            &:nth-child(2){width: 200px;}
            &:nth-child(3){width: 100px;}
            &:nth-child(4){flex: 1;}
            &:nth-child(5){width: 300px;}
          }
          &:nth-child(1){
            div{
              font-weight: 600;
            }
          }
        }
      }
    }
    /deep/ .tooltip_hv{
      position: relative;
      color: #fff;
    }
    .no_data{
      text-align: center;
      img{
        width: 100px;
        margin-top: 50px;
      }
      p{
        margin-top: 15px;
        font-size: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/classStatistics/comp/comprehensiveStatistics.vue